import service from '@/utils/server';

const modName='/bd/soldBatch/';
//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};
//初始化页面对象
export const initPage = data => {
  return service({
    url: modName + 'initPage',
    method: 'post',
    data
  });
};

//导出
export const downloadTemplate = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'template/' + data.templateName,
    method: 'post',
    data
  });
};

//导入
export const uploadOrder = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    headers: {
      "Content-Type": "multipart/form-data"
    },
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'uploadOrder',
    method: 'post',
    data
  });
};
//提交
export const submit = data => {
  return service({
    url: modName + 'submit',
    method: 'post',
    data
  });
};

//删除
export const deleteOrder = id => {
  return service({
    url: modName + 'delete/' + id,
    method: 'post'
  });
};



// WEBPACK FOOTER //
// ./src/page/order/soldBatch/api/index.js